// Constant variables used for jquery selecting
var DROPDOWN_CSS_SELECTOR = ".wm-intro-wrapper .country-select";
var DROPDOWN_SELECTED_CSS_SELECTOR = ".wm-intro-wrapper .country-select option:selected";
var CONTACT_CSS_SELECTOR = ".wm-intro-wrapper .jump-nav--contact";
var HOME_CSS_SELECTOR = ".wm-intro-wrapper .jump-nav--website";
var selectedVal;

$(window).on('load', function () {
    onJumpChange();
});

$(document).ready(function () {
    // Setup event listener for the "Go" button.
    $(CONTACT_CSS_SELECTOR).on('click', function (e) { jumpListGo("CONTACT", e); });
    $(HOME_CSS_SELECTOR).on('click', function (e) { jumpListGo("HOME", e); });

    $(DROPDOWN_CSS_SELECTOR).on('change', onJumpChange);

    onJumpChange();
});

function onJumpChange() {
    selectedVal = $(DROPDOWN_CSS_SELECTOR).val();

    if (typeof selectedVal === "undefined" || selectedVal === "") {
        $(CONTACT_CSS_SELECTOR).addClass('disabled');
        $(HOME_CSS_SELECTOR).addClass('disabled');
    } else {
        $(HOME_CSS_SELECTOR).removeClass('disabled');
        $(CONTACT_CSS_SELECTOR).removeClass('disabled');
    }
}

function jumpListGo(type, e) {
    e.preventDefault();

    // Grab the value from the select dropdown
    var $selectedOpt = $(DROPDOWN_SELECTED_CSS_SELECTOR);
    var newUrl;

    // Error handling on the value
    if ($selectedOpt.length <= 0 || $selectedOpt.val() === "") {
        $(CONTACT_CSS_SELECTOR).addClass('disabled');
        $(HOME_CSS_SELECTOR).addClass('disabled');
        return false;
    }

    if ($(".wm-intro-wrapper .btn.disabled").length > 0) { return; } // Buttons are disabled so don't go to them

    // Construct the new url path
    if (type === "CONTACT") {
        newUrl = window.location.origin + $selectedOpt.attr("data-contact");

    } else if (type === "HOME") {

       if (selectedVal && Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          'event': 'modal_interaction',
          'eventCategory': 'Region Selector',
          'eventAction': 'Click',
          'eventLabel': selectedVal
        });
       }
      
        newUrl = window.location.origin + $selectedOpt.attr("data-home");
    }

    // Go to url path
    window.location.href = newUrl;
}

//# sourceMappingURL=canaccord.jumpList.js.map
